
import { Link } from "react-router-dom";
import { ProfileMenu } from "@/components/auth/ProfileMenu";

interface ProjectHeaderProps {
  onNewProject?: () => void;
}

export function ProjectHeader({ onNewProject }: ProjectHeaderProps) {
  return (
    <div className="space-y-6">
      <header className="flex justify-between items-center backdrop-blur-sm p-4 rounded-xl border border-white/5 glass-card shadow-lg">
        <Link to="/" className="text-3xl font-brakle font-bold bg-gradient-to-r from-white via-purple-100 to-purple-200 text-transparent bg-clip-text">
          PREPT.
        </Link>
        <div className="flex items-center gap-2">
          <ProfileMenu />
        </div>
      </header>
    </div>
  );
}
